import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {ComputeOptionsRequest} from '../api';
import {
  AXIOS_CANCEL_MSG,
  CategoryIdAssembliesIdMap,
} from '../api/models';
import { ConfiguratorContext } from '../context';


interface ComputedValidProps {
  modelId:number | undefined,
  options?:ComputeOptionsRequest
}

export const useComputedValid = (props: ComputedValidProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:ComputedValidProps  ) : Promise<CategoryIdAssembliesIdMap | undefined> => {

    const { modelId, options } = props;
    if (!modelId) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.computeValid(modelId, options, cancelSource.token );
      cancelTokenSourceRef.current = undefined;

      return resp.data.selections;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
    'computeValid',
    props
  ],
    ([_k, p]) => fetcher(p),
    {
      shouldRetryOnError: true,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: false,
      dedupingInterval:1
    }
  );
};


export default useComputedValid;

